import RowGroup from "./RowGroup"

export default function RowGroups({
  onGroupCollapseStateChanged,
  onRowClick,
  rowGroups,
  collapsedGroups,
}) {
  function handleGroupCollapseToggle(groupKey) {
    const newCollapsedGroups = collapsedGroups.includes(groupKey)
      ? collapsedGroups.filter((el) => el !== groupKey)
      : collapsedGroups.concat([groupKey])

    onGroupCollapseStateChanged(newCollapsedGroups)
  }

  return rowGroups.map((group, n) => {
    return (
      <RowGroup
        key={group.groupKey || "none"}
        groupNumber={n}
        onRowClick={onRowClick}
        onGroupCollapseToggle={handleGroupCollapseToggle}
        {...group}
      />
    )
  })
}
